import { Text } from 'react-native'
import { useTranslation } from 'react-i18next'
import { CashierSuccessView } from '../shared/CashierSuccessView'

export interface RedemptionResult {
  rewardName: { en: string; sv: string }
  quantity: number
  memberFullName: string
  memberFirstName: string
  remainingCount: number
}

interface RewardRedeemedViewProps {
  result: RedemptionResult
  onScanNext: () => void
  onDone: () => void
}

export function RewardRedeemedView({ result, onScanNext, onDone }: RewardRedeemedViewProps) {
  const { t, i18n } = useTranslation()
  const { quantity, memberFullName, memberFirstName, remainingCount } = result
  const lang = (i18n.language === 'sv' ? 'sv' : 'en') as 'en' | 'sv'
  const rewardName = result.rewardName[lang] || result.rewardName.en

  const usedLabel = quantity === 1
    ? t('rewardRedemption.success.usedSingle', { rewardName, fullName: memberFullName })
    : t('rewardRedemption.success.used', { count: quantity, rewardName, fullName: memberFullName })

  return (
    <CashierSuccessView
      title={t('rewardRedemption.success.title')}
      scanNextLabel={t('rewardRedemption.success.scanNext')}
      doneLabel={t('rewardRedemption.success.done')}
      onScanNext={onScanNext}
      onDone={onDone}
    >
      <Text className="text-base lg:text-lg text-secondary text-center">
        {usedLabel}
      </Text>

      <Text className="text-base lg:text-lg text-secondary text-center">
        {t('rewardRedemption.success.remainingPrefix', { firstName: memberFirstName })}{' '}
        <Text className="font-bold text-accent">{remainingCount}</Text>
        {' '}{t('rewardRedemption.success.remainingSuffix', { rewardName })}
      </Text>
    </CashierSuccessView>
  )
}